/* eslint-disable @typescript-eslint/no-explicit-any */
import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';

type ReduxRI = ThunkAction<void, any, unknown, Action<string>>;

// Action to Re-sync necessary Info
export const loginStatus =
    (status = 'LOGIN'): ReduxRI =>
        (dispatch) => {
            dispatch({
                type: 'LOGIN_STATUS',
                state: {
                    status: status,
                },
            });
        };

export const showNotification =
    (message: string, error = false): ReduxRI =>
        (dispatch) => {
            dispatch({
                type: 'showToast',
                state: {
                    error: error,
                    message: message,
                },
            });
        };

export const setBackendDown = (status="") => ({
    type: "SET_BACKEND_DOWN",
    payload: status,
});

export const success =
    (
        message: string,
        action?: { content: ''; onAction: () => void },
        duration?: number
    ): ReduxRI =>
        (dispatch) => {
            dispatch({
                type: 'showToast',
                state: {
                    error: false,
                    message: message,
                    action: action,
                    duration: duration,
                },
            });
        };

export const error =
    (
        message: string,
        action?: { content: ''; onAction: () => void },
        duration?: number
    ): ReduxRI =>
        (dispatch) => {
            dispatch({
                type: 'showToast',
                state: {
                    error: true,
                    message: message,
                    action: action,
                    duration: duration,
                },
            });
        };

export const info =
    (
        message: string,
        action?: { content: ''; onAction: () => void },
        duration?: number
    ): ReduxRI =>
        (dispatch) => {
            dispatch({
                type: 'showToast',
                state: {
                    info: true,
                    message: message,
                    action: action,
                    duration: duration,
                },
            });
        };

// export const warn =
//     (
//         message: string,
//         action?: { content: ''; onAction: () => void },
//         duration?: number
//     ): ReduxRI =>
//     (dispatch) => {
//         dispatch({
//             type: 'showToast',
//             state: {
//                 error: false,
//                 warn: true,
//                 message: message,
//                 action: action,
//                 duration: duration,
//             },
//         });
//     };

export const hideNotification =
    (id: string | number): ReduxRI =>
        (dispatch) => {
            dispatch({
                type: 'hideToast',
                state: {
                    id: id,
                },
            });
        };
